import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '@app-core/services/data/data.service';

interface UnsavedDialogData {
  onCancelModal: () => void;
  onSaveReport: () => void;
}

@Component({
  selector: 'app-unsave-report-modal',
  templateUrl: './unsave-report-modal.component.html',
  styleUrls: ['./unsave-report-modal.component.scss'],
})
export class UnsavedReportModalComponent {
  constructor(
    public dialogRef: MatDialogRef<UnsavedReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnsavedDialogData,
    public dataService: DataService
  ) {}

  onClose() {
    this.dialogRef.close({ action: 'close' });
  }

  onDiscard() {
    this.dialogRef.close({ action: 'discard' });

    if (this.data?.onCancelModal) {
      this.data.onCancelModal();
    }
  }

  onSave() {
    this.dialogRef.close({ action: 'save' });
    if (this.data?.onSaveReport) {
      this.data.onSaveReport();
    }
  }
}
